import { useState } from "react";
import { X } from "react-bootstrap-icons";

const NickNameModal = ({ nickname, onSave, onClose }) => {
    const defaultNickname = nickname || "";
    const [userNickName, setUserNickName] = useState(defaultNickname);
    const [errors, setErrors] = useState({ nickname: "" });

    const validateNickName = (nickName) => {
        if (!nickName.trim()) return "Nickname is required";
        if (nickName.length < 2) return "Nickname must be at least 2 characters long";
        if (nickName.length > 30) return "Nickname must be less than 30 characters";
        return "";
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const nickNameError = validateNickName(userNickName);
        if (nickNameError) {
            setErrors((prev) => ({ ...prev, nickname: nickNameError }));
            return;
        }
        onSave(userNickName);
    };

    return (
        <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-bg-black/40 tw-flex tw-items-center tw-justify-center">
            <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-p-5 tw-w-full tw-max-w-sm tw-relative">
                <h2 className="tw-text-center tw-text-xl tw-font-bold tw-mb-2">Choose your nickname</h2>
                <p className="tw-text-center tw-text-gray-500 tw-text-sm tw-mb-6">
                    This is the public name other users see next to your comments
                </p>
                <form onSubmit={onSubmit}>
                    <div className="tw-relative tw-mb-2">
                        <input
                            value={userNickName}
                            onChange={(e) => setUserNickName(e.target.value)}
                            className="tw-w-full tw-border tw-border-gray-300 tw-rounded-lg tw-py-2 tw-pl-4 tw-pr-10 tw-text-base"
                            placeholder="Enter a nickname"
                            maxLength={30}
                        />
                        {userNickName && (
                            <button
                                type="button"
                                className="tw-absolute tw-right-2 tw-top-1/2 -translate-y-1/2 tw-bg-transparent tw-p-1"
                                onClick={() => setUserNickName("")}
                                tabIndex={-1}
                                aria-label="Clear"
                            >
                                <X className="tw-w-4 tw-h-4 tw-text-gray-400 hover:tw-text-gray-600" />
                            </button>
                        )}
                    </div>
                    {errors.nickname && (
                        <p className="tw-text-red-500 tw-text-xs tw-mb-2">{errors.nickname}</p>
                    )}
                    <div className="tw-flex tw-gap-3 tw-mt-6">
                        <button
                            type="button"
                            className="tw-flex-1 tw-text-[#F69929] tw-bg-[#F69929] tw-bg-opacity-15 tw-font-semibold tw-py-2 tw-rounded-lg"
                            onClick={onClose}
                        >
                            Back
                        </button>
                        <button
                            type="submit"
                            className="tw-flex-1 tw-bg-[#FF9900] tw-text-white tw-font-semibold tw-py-2 tw-rounded-lg hover:tw-bg-[#e88a00] tw-transition"
                        >
                            Done
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NickNameModal;
